"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TermsAndConditions_1 = require("./TermsAndConditions");
exports.default = TermsAndConditions_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/TermsAndConditions/index.js
// module id = 1336
// module chunks = 8